import { useAppDispatch, useAppSelector } from "hooks";
import React, { useEffect } from "react";
import { simFlowFetchData, simFlowFetchSimRequestData } from "../../../../redux/simFlow/simFlowSlice";
import CommonLoader from "components/CommonLoader";

type GenerateCheckDigitProps = {
  id: any;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
function GenerateCheckDigit({ id }: GenerateCheckDigitProps) {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const simSelectorData = useAppSelector((state) => state.simFlow.simFlow.data[3].data);
  const [simSelector, setSimSelector] = React.useState<any>(simSelectorData);

  const simError = useAppSelector((state) => state.errorStep.simError);
  const isError = simError ? simError.step >= 5 : false;
  const isAlreadyFetched =
    simSelectorData instanceof Array
      ? false
      : "status" in simSelectorData
        ? true
        : simSelectorData.flow_dtl_id === Number(id);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isError && !isAlreadyFetched) {
      dispatch(simFlowFetchData());
      dispatch(simFlowFetchSimRequestData({ id, stepId: 5 }));
    } else {
      setSimSelector(simSelectorData);
    }
  }, [dispatch, id, isAlreadyFetched, isError, simSelectorData]);
  const simSelectorLoading = useAppSelector((state) => state.simFlow.simFlow.loading);

  const vehicleIdentifierData: Array<any> = [
    {
      id: 1,
      name: "Vin Check Digit",
      value: simSelector.request_json?.oldVinCheckDigit ?? "",
    },
    {
      id: 2,
      name: "Serial Check Digit",
      value: simSelector.request_json?.oldSerialCheckDigit ?? "",
    },
    {
      id: 3,
      name: "Pre Prod Vin",
      value: simSelector.request_json?.oldPreProdVin ?? "",
    },
  ];

  const renderData: Array<any> = [
    {
      id: 1,
      title: "Vehicle Identifier",
      data: vehicleIdentifierData,
    },
  ];
  // console.log("renderData", RequestedConfiguration[4]);

  if (simSelectorLoading) {
    return <CommonLoader active={simSelectorLoading} />;
  }
  return (
    <>
      <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
        {renderData.map((item) => {
          return (
            <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
              <div className="flex w-full justify-start items-center content-center">
                <span className="font-bold mx-4 text-xl">{item.title}</span>
              </div>
              <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
              <div className="grid grid-cols-3 m-4 gap-4">
                {item.data.map((items: any) => (
                  <div className="" key={items.id}>
                    <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                      <div className="text-base">{items.name}</div>
                      <div className="text-base">{items.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default GenerateCheckDigit;
